import React from 'react'

const OneSmallStep = () => {
    return (
        <div className="hciContent">
            <h1 className="heading1">One Small Step</h1>
            <h2 className="heading2">CSI-370: Computer Architecture Final Project</h2>
            <p className="descriptionText">Created a 3D single-stage rocket simulation using WASM, React Three Fiber, and TypeScript</p>

            <div className="social-icons">
                <a target="_blank" href="https://www.linkedin.com/in/derisomalley/details/projects/"><i className='bx bxl-linkedin'></i></a>
                <a target="_blank" href="https://github.com/DerisO22/One_Small_Step"><i className='bx bxl-github'></i></a>
            </div>

            {/* <!-- Example Images --> */}
            <h2 className="app_examples_header">From The Project</h2>

            <div className="imageExampleContainerHCI">
                <div className="image1_container">
                    <img className="example_image1" src="/smallstep_assets/oneSmallStepLook.webp" alt="Before rocket launch view with leva debug menu"></img>
                    <div className="phonici_example1_overlay">
                        <div className="overlay_text">View of App Before Rocket Launch with leva debug menu</div>
                    </div>
                </div>
                <div className="image2_container">
                    <img className="example_image2" src="/smallstep_assets/one_small_step.webp" alt="View of Rocket Above Atmosphere slightly pitched"></img>
                    <div className="phonici_example2_overlay">
                        <div className="overlay_text">Rocket Adjusting pitch throughout trajectory</div>
                    </div>
                </div>
            </div>
        </div>  
    )
}

export default OneSmallStep
